var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 44,
    viewBox: "0 0 29 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F17884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CA1528"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    stroke: "#D23444",
    d: "M569.045 428.955c-5.273-5.273-13.816-5.273-19.09 0-5.273 5.27-5.273 13.821 0 19.09 0 0 8.484 8.32 9.45 18.326.058.604.089.214.089.83 0-.617.03-.228.09-.834.968-10.004 9.46-18.322 9.46-18.322 5.275-5.269 5.275-13.82.001-19.09z",
    transform: "translate(-545 -424)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.27b7f5596fc868044abc3586d468b68b.svg";
export { ForwardRef as ReactComponent };